"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Accordion = void 0;
var _fuseUtils = require("@tvg/fuse-utils");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _accordionConfig = _interopRequireDefault(require("./accordion-config"));
var _styledAccordion = require("./styled-accordion");
var _excluded = ["chevronInline", "children", "collapseCallback", "dataTestId", "expandCallback", "heading", "headingTag", "hideBorder", "open", "titleSize", "componentId"];
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var headingSizeConfig = _accordionConfig["default"].heading;
var forwardRef = _react["default"].forwardRef,
  useCallback = _react["default"].useCallback,
  useEffect = _react["default"].useEffect,
  useMemo = _react["default"].useMemo,
  useState = _react["default"].useState;
var propTypes = {
  chevronInline: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  collapseCallback: _propTypes["default"].func,
  dataTestId: _propTypes["default"].string,
  expandCallback: _propTypes["default"].func,
  heading: _propTypes["default"].string,
  headingTag: _propTypes["default"].string,
  hideBorder: _propTypes["default"].bool,
  open: _propTypes["default"].bool,
  titleSize: _propTypes["default"].oneOfType([_propTypes["default"].shape(['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl'].reduce(function (acc, current) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, current, _propTypes["default"].oneOf(Object.keys(headingSizeConfig))));
  }, {}))]),
  componentId: _propTypes["default"].string
};
var defaultProps = {
  chevronInline: false,
  children: null,
  collapseCallback: function collapseCallback() {},
  dataTestId: undefined,
  expandCallback: function expandCallback() {},
  heading: '',
  headingTag: 'h3',
  hideBorder: false,
  open: false,
  titleSize: {
    xxs: 'xxsmall'
  },
  componentId: (0, _fuseUtils.uuid)()
};
var Accordion = exports.Accordion = forwardRef(function (_ref, ref) {
  var chevronInline = _ref.chevronInline,
    children = _ref.children,
    collapseCallback = _ref.collapseCallback,
    dataTestId = _ref.dataTestId,
    expandCallback = _ref.expandCallback,
    heading = _ref.heading,
    headingTag = _ref.headingTag,
    hideBorder = _ref.hideBorder,
    open = _ref.open,
    titleSize = _ref.titleSize,
    componentId = _ref.componentId,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var buttonId = useMemo(function () {
    return "fuse-accordion-button-".concat(componentId);
  }, []);
  var contentId = useMemo(function () {
    return "fuse-accordion-content-".concat(componentId);
  }, []);
  var headingSize = useMemo(function () {
    return {
      // Map titleSize viewport sizes to heading typography element viewport sizes i.e. { xxs: 'medium', m: 'large', l: 'xlarge' } to { xxs: '4',  m: '5', l: '6' }
      xxs: headingSizeConfig[titleSize.xxs],
      xs: headingSizeConfig[titleSize.xs],
      s: headingSizeConfig[titleSize.s],
      m: headingSizeConfig[titleSize.m],
      l: headingSizeConfig[titleSize.l],
      xl: headingSizeConfig[titleSize.xl],
      xxl: headingSizeConfig[titleSize.xxl]
    };
  }, [titleSize]);
  var handleClick = useCallback(function (e) {
    if (isOpen) {
      setIsOpen(false);
      collapseCallback(e);
    } else {
      setIsOpen(true);
      expandCallback(e);
    }
  }, [isOpen]); // Toggle accordion to expand and collapse

  // Set the accordion to open or close based on the 'open' prop value
  useEffect(function () {
    if (open) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [open]);
  return /*#__PURE__*/_react["default"].createElement(_styledAccordion.StyledAccordion, _extends({
    className: "".concat(isOpen ? 'fuse-accordion__open' : 'fuse-accordion__closed'),
    "data-testid": dataTestId || 'fuse-accordion',
    hideBorder: hideBorder,
    ref: ref
  }, props), /*#__PURE__*/_react["default"].createElement(_styledAccordion.StyledAccordionHeader, {
    as: headingTag
  }, /*#__PURE__*/_react["default"].createElement(_styledAccordion.StyledAccordionButton, {
    "aria-controls": contentId,
    "aria-expanded": isOpen,
    onClick: handleClick,
    open: isOpen,
    type: "button",
    id: buttonId,
    titleSize: titleSize
  }, /*#__PURE__*/_react["default"].createElement(_styledAccordion.StyledAccordionHeading, {
    chevronInline: chevronInline,
    type: "heading",
    tag: "span",
    size: headingSize
  }, heading))), /*#__PURE__*/_react["default"].createElement(_styledAccordion.StyledAccordionContent, {
    "aria-hidden": isOpen ? undefined : true,
    "aria-labelledby": buttonId,
    className: "".concat(isOpen ? '' : 'fuse-acccordion__content--hide'),
    id: contentId,
    role: "region"
  }, children));
});
Accordion.propTypes = propTypes;
Accordion.defaultProps = defaultProps;
var _default = exports["default"] = Accordion;